import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Discover",
    desc: "We dig into your brand, market and audience until we understand what actually moves the needle.",
  },
  {
    n: "02",
    title: "Strategise",
    desc: "A sharp, no-nonsense growth plan. Channels, messaging and creative mapped to real objectives.",
  },
  {
    n: "03",
    title: "Launch",
    desc: "Campaigns go live with tight tracking. We move fast, test hard and kill what doesn't work.",
  },
  {
    n: "04",
    title: "Scale",
    desc: "Winners get fuel. We compound the wins and turn steady growth into serious momentum.",
  },
];

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-32 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-14">
        {/* Left sticky intro + image */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <span className="text-xs tracking-[0.3em] uppercase text-yellow-400 font-semibold">
              02 — Process
            </span>
            <h2 className="mt-6 font-display font-semibold tracking-tight text-white text-4xl sm:text-6xl uppercase leading-[0.95]">
              Our <br />
              <span className="text-yellow-400">Process</span>
            </h2>
            <p className="mt-6 text-zinc-400 leading-relaxed max-w-sm">
              No bloated retainers. No vanity metrics. Just a clear, repeatable
              path from where you are to where you want to be.
            </p>

            <motion.div
              initial={{ opacity: 0, scale: 0.92 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              className="mt-10 border border-white/10"
              data-testid="process-image"
            >
              <img
                src="/images/process.png"
                alt="Brand growth character climbing steps"
                className="w-full select-none"
                draggable={false}
              />
            </motion.div>
          </div>
        </div>

        {/* Steps */}
        <div className="lg:col-span-7">
          <div className="border-t border-white/10">
            {steps.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                data-testid={`process-step-${s.n}`}
                className="group flex gap-6 md:gap-12 py-10 border-b border-white/10 hover:pl-2 transition-all"
              >
                <span className="font-display text-3xl md:text-5xl text-yellow-400 shrink-0 w-16">
                  {s.n}
                </span>
                <div>
                  <h3 className="font-display text-2xl md:text-4xl text-white tracking-tight mb-3">
                    {s.title}
                  </h3>
                  <p className="text-zinc-400 leading-relaxed max-w-xl">
                    {s.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
